var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFcWarrantyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 208,
    viewBox: "0 0 135 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.682 207.312H7.8C3.492 207.312 0 203.82 0 199.512V99.8C0 95.492 3.492 92 7.8 92H126.682C130.99 92 134.482 95.492 134.482 99.8V199.512C134.482 203.82 130.99 207.312 126.682 207.312Z",
    fill: "url(#paint0_linear_284_858)",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.682 92C125.467 92 124.482 92.985 124.482 94.2V189.512C124.482 193.82 120.99 197.312 116.682 197.312H2.2C0.984977 197.312 0 198.297 0 199.512C0 203.82 3.492 207.312 7.8 207.312H126.682C130.99 207.312 134.482 203.82 134.482 199.512V99.8C134.482 95.492 130.99 92 126.682 92Z",
    fill: "#2A3A56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.034 93.5276C130.208 92.9257 129.242 93.8076 129.242 94.8291V194.541C129.242 198.849 125.75 202.341 121.442 202.341H2.55904C1.53757 202.341 0.655608 203.307 1.25737 204.133C2.67479 206.077 4.9682 207.341 7.55904 207.341H126.441C130.749 207.341 134.241 203.849 134.241 199.541V99.8291C134.241 97.239 132.978 94.9452 131.034 93.5276Z",
    fill: "url(#paint1_linear_284_858)",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.016 92.0289H104.515V58.3789C104.515 37.8929 88.3851 20.6549 67.9051 20.1709C46.8081 19.6719 29.4861 36.6889 29.4861 57.6749V70.0289C29.4861 71.1339 28.5911 72.0289 27.4861 72.0289H11.9841C10.8791 72.0289 9.98413 71.1339 9.98413 70.0289V58.5399C9.98413 27.2509 34.8301 1.14194 66.1151 0.664941C97.9581 0.179941 124.016 25.9409 124.016 57.6739V92.0289Z",
    fill: "#FFD956"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.525 13.799C111.726 23.676 116.666 36.3549 116.666 50.166V84.5199H104.673V92.028H124.174V57.675C124.173 40.048 116.131 24.266 103.525 13.799Z",
    fill: "#FFD956"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76001 119.99C4.66001 119.99 3.76001 119.099 3.76001 117.99C3.76001 116.889 4.66001 115.99 5.76001 115.99C6.86001 115.99 7.76001 116.889 7.76001 117.99C7.76001 119.1 6.86001 119.99 5.76001 119.99ZM5.76001 111.99C4.66001 111.99 3.76001 111.099 3.76001 109.99V99.83C3.76001 97.74 5.47001 96.03 7.56001 96.03H109.61C110.71 96.03 111.61 96.929 111.61 98.03C111.61 99.13 110.71 100.03 109.61 100.03H7.76001V109.979V109.99C7.76001 111.1 6.86001 111.99 5.76001 111.99Z",
    fill: "#FFD956"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.165 119C49.953 119 36 132.953 36 150.165C36 167.377 49.953 181.33 67.165 181.33C84.377 181.33 98.33 167.377 98.33 150.165C98.33 132.953 84.377 119 67.165 119ZM67.165 163.816C59.626 163.816 53.514 157.704 53.514 150.165C53.514 142.626 59.626 136.514 67.165 136.514C74.704 136.514 80.816 142.626 80.816 150.165C80.816 157.704 74.704 163.816 67.165 163.816Z",
    fill: "#FFD956"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7789 125.227C89.7289 130.45 92.0739 136.953 92.0739 144.006C92.0739 161.218 78.1209 175.171 60.9089 175.171C53.8559 175.171 47.3529 172.825 42.1299 168.876C47.8189 176.399 56.8409 181.262 66.9999 181.262C84.2119 181.262 98.1649 167.309 98.1649 150.097C98.1649 139.938 93.3019 130.917 85.7789 125.227Z",
    fill: "#FFD956"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.355 143.01L104.932 136.326C106.073 135.32 106.346 133.649 105.585 132.331L101.555 125.351C100.794 124.034 99.21 123.435 97.768 123.92L88.105 127.168C92.628 131.332 95.915 136.816 97.355 143.01Z",
    fill: "#FFD956"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.068 136.326L36.645 143.01C38.085 136.817 41.372 131.332 45.894 127.168L36.231 123.92C34.789 123.435 33.205 124.034 32.444 125.351L28.414 132.331C27.653 133.648 27.927 135.319 29.068 136.326Z",
    fill: "#FFD956"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67 118.932C70.175 118.932 73.239 119.407 76.125 120.29L74.163 110.575C73.862 109.084 72.551 108.012 71.03 108.012H62.97C61.449 108.012 60.138 109.084 59.837 110.575L57.875 120.29C60.761 119.407 63.825 118.932 67 118.932Z",
    fill: "#FFD956"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M104.686 163.441L97.395 157.009C96.005 163.149 92.801 168.601 88.377 172.773L97.5229 175.848C98.9649 176.333 100.549 175.734 101.31 174.416L105.34 167.436C106.1 166.119 105.827 164.448 104.686 163.441Z",
    fill: "#FFD956"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67 181.262C63.825 181.262 60.761 180.787 57.875 179.904L59.837 189.619C60.138 191.11 61.449 192.182 62.97 192.182H71.03C72.551 192.182 73.862 191.11 74.163 189.619L76.125 179.904C73.239 180.787 70.175 181.262 67 181.262Z",
    fill: "#FFD956"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6049 157.009L29.3139 163.441C28.1729 164.448 27.8999 166.119 28.6609 167.436L32.6909 174.416C33.4519 175.734 35.0359 176.332 36.4779 175.848L45.6239 172.773C41.1989 168.602 37.9949 163.15 36.6049 157.009Z",
    fill: "#FFD956"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_858",
    x1: -17.7546,
    y1: 109.503,
    x2: 144.148,
    y2: 132.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_858",
    x1: -17.5598,
    y1: 109.858,
    x2: 143.876,
    y2: 132.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4DE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A9CFB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFcWarrantyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fc-warranty-icon.66a78b925018337c06265ff73a6c5f9d.svg";